import Box from "../../../../components/Box";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextInput from "../../../../components/CustomTextInput";
import { CompanyService } from "../../../../services/CompanyService";
import { DriverService } from "../../../../services/DriverService";
import { VehicleService } from "../../../../services/VehicleService";
import { ConstantService } from "../../../../services/ConstantService";
import { AmbarVoyageService } from "../../../../services/AmbarVoyageService";
import { useDispatch } from "react-redux";
import { storeActivityIndicator, storeEbbeModalCallback } from "../../../../redux/reducers/authSlice";
import toast from "react-hot-toast";

interface Props {
    ambarVoyageId: string | undefined
    endDateStr: string | null | undefined
    setEndDateStr: React.Dispatch<React.SetStateAction<string | null | undefined>>
    selectedVehicle: CustomSingleSelectModel | undefined
    setSelectedVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    isCustomActive: boolean
    selectedPricingVehicleType: CustomSingleSelectModel | undefined
    setSelectedPricingVehicleType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    selectedTrailer: CustomSingleSelectModel | undefined
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSupplier: CustomSingleSelectModel | undefined
    setSelectedSupplier: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDriver: CustomSingleSelectModel | undefined
    setSelectedDriver: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const GeneralInformation = ({
    ambarVoyageId,
    endDateStr,
    setEndDateStr,
    selectedVehicle,
    setSelectedVehicle,
    refNo,
    setRefNo,
    isCustomActive,
    selectedPricingVehicleType,
    setSelectedPricingVehicleType,
    setIsCustomActive,
    selectedTrailer,
    setSelectedTrailer,
    selectedSupplier,
    setSelectedSupplier,
    selectedDriver,
    setSelectedDriver
}: Props) => {
    const dispatch = useDispatch();

    // Kayitli seferde isaret tiklanabilir; Seferi Bitir ile kapanan sefer yeniden acilamaz (sunucu da denetler).
    const acilamaz = !isCustomActive && !!endDateStr;
    const tiklanabilir = !!ambarVoyageId && !acilamaz;

    const isaretBasligi = isCustomActive
        ? (tiklanabilir ? 'Sefer Aktif — pasife almak için tıklayın' : 'Sefer Aktif')
        : (acilamaz ? 'Sefer Pasif — Seferi Bitir ile kapandı (' + endDateStr + ')' : (tiklanabilir ? 'Sefer Pasif — yeniden açmak için tıklayın' : 'Sefer Pasif'));

    // Web'den Seferi Bitir (16.10.2026, Burak): bitis zamani sorulmaz, sunucu son teslim zamanini yazar.
    const seferiBitir = async () => {
        if (!ambarVoyageId) return;

        try {
            dispatch(storeActivityIndicator(true));
            var response = await AmbarVoyageService.seferiBitir(ambarVoyageId);

            if (!response.isSuccess) {
                toast.error(response.message, { duration: 8000 });
                return;
            }

            setIsCustomActive(response.data.isCustomActive);
            setEndDateStr(response.data.endDateStr);
            toast.success(response.message);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    };

    const aktifligiDegistir = () => {
        if (!tiklanabilir || !ambarVoyageId) return;

        const aktif = !isCustomActive;

        dispatch(storeEbbeModalCallback({
            title: aktif ? 'Seferi Yeniden Aç' : 'Seferi Pasife Al',
            body: aktif
                ? 'Sefer yeniden aktif olacak ve Sefere Bağla listesinde görünecek. Seferi kalıcı kapatmak için Seferi Bitir kullanılabilir: bitiş zamanı seferdeki siparişlerin en geç teslim zamanı olur, sefer bir daha açılamaz.'
                : 'Pasife Al: sefer Sefere Bağla listesinden çıkar, sonra yeniden açılabilir. Seferi Bitir: bitiş zamanı seferdeki siparişlerin en geç teslim zamanı olur, sefer bir daha açılamaz (teslim tarih ve saati eksik sipariş varsa bitirilemez).',
            buttons: [
                { text: 'Vazgeç', btnClass: 'btn-warning' },
                { text: 'Seferi Bitir', btnClass: 'btn-danger', onClick: seferiBitir },
                {
                    text: aktif ? 'Yeniden Aç' : 'Pasife Al',
                    btnClass: 'btn-success',
                    onClick: async () => {
                        try {
                            dispatch(storeActivityIndicator(true));
                            var response = await AmbarVoyageService.seferAktifligiDegistir(ambarVoyageId, aktif);

                            if (!response.isSuccess) {
                                toast.error(response.message);
                                return;
                            }

                            setIsCustomActive(response.data.isCustomActive);
                            toast.success(response.message);
                        } catch (error: any) {
                            toast.error(error);
                        } finally {
                            dispatch(storeActivityIndicator(false));
                        }
                    }
                }
            ]
        }));
    };

    return (
        <div>
            <KTCard className="ebbe-card">
                <KTCardBody>
                    <Box className="mb-10" flexDirection="row" alignItems="center">
                        <Box flexGrow={1} justifyContent="center">
                            <h4 className="text-black m-0">Genel Bilgiler</h4>
                        </Box>
                        <Box justifyContent="center" mr="10px">
                                <Box
                                    title={isaretBasligi}
                                    onClick={tiklanabilir ? aktifligiDegistir : undefined}
                                    className={(isCustomActive ? "p-2 bg-light-success" : "p-2 bg-light-danger") + (tiklanabilir ? " cursor-pointer" : "")}
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDirection="row"
                                    width="34px"
                                    height="34px"
                                    borderRadius="4px">
                                    <i className={isCustomActive ? "fa fa-circle-play text-success" : "fa fa-circle-stop text-danger"} style={{ fontSize: 16 }} />
                                </Box>
                            </Box>
                    </Box>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Araç Plaka"
                                selectedValue={selectedVehicle}
                                onChange={setSelectedVehicle}
                                onMenuOpen={() => VehicleService.getVehicleList(["1", "2", "4", "5"])}
                                labelName='plate'
                                valueName='vehicleId'
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText='Sefer No' isLabelRequired value={refNo} setValue={setRefNo} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Fiyatlanacak Araç Cinsi"
                                selectedValue={selectedPricingVehicleType}
                                onChange={setSelectedPricingVehicleType}
                                insertable={{ onSubmit: { code: 'VEHICLE_TYPE_2' } }}
                                onMenuOpen={() => ConstantService.getConstantList('VEHICLE_TYPE_2')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Dorse Plaka"
                                selectedValue={selectedTrailer}
                                onChange={setSelectedTrailer}
                                onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                labelName='plate'
                                valueName='vehicleId'
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Tedarikçi"
                                selectedValue={selectedSupplier}
                                onChange={setSelectedSupplier}
                                onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                labelName='name'
                                valueName='companyId'
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Sürücü"
                                selectedValue={selectedDriver}
                                onChange={setSelectedDriver}
                                onMenuOpen={() => DriverService.getDriverList()}
                                labelName='nameSurname'
                                valueName='driverId'
                                disabled
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;